<template>
  <div>
    <div class="companies-container">
      <PasswordExpired
        v-if="passwordExpired"
        @goto-switch-company="goToSwitchCompany"
        @goto-dashboard="switchCompanySession(userId, companyState)"
      />
      <template v-else>
        <div class="pt-6 w-11/12 flex mx-auto">
          <div class="flex border-2 rounded border-zt-primary-100 box-custom-height md:h-32">
            <div class="w-2/6 md:w-1/4 m-auto">
              <div class="w-24 h-16 md:w-32 md:h-20 flex justify-center items-center mx-auto border rounded border-custom-gray-2">
                <div
                  class="logo-company-change-box flex items-center justify-center"
                    v-show="imageLoaded"
                >
                  <img
                    :src="companyLogo"
                    @load="handleImageLoad"
                    @error="handleImageError"
                    alt=""
                  />
                  <div v-show="!imageLoaded" class="loading-placeholder">
                    <zt-icon name="image" class="text-zt-xl text-gray-400"/>
                  </div>
                </div>
              </div>
            </div>
            <div class="w-3/6 md:w-2/4 py-4 flex flex-wrap">
              <span class="w-full font-bold text-zt-dark-500">{{ currentCompany.empresa.nombre }}</span>
              <span class="w-full company-info">{{ currentCompany.pais }}</span>
            </div>
            <div class="w-1/6 md:w-1/4 my-auto pr-10 pl-2 flex">
              <zt-icon name="location" class="text-zt-xl"/>
              <span class="ml-2 text-zt-dark-300 hidden md:flex">
                {{
                  $t(
                    'message.settingsComponent.list.switchCompany.stateCurrentCompany'
                  )
                }}
              </span>
            </div>
          </div>
        </div>
        <div class="mt-6 mb-10 w-11/12 flex mx-auto">
          <span class="companies-title font-bold text-zt-lg">
            {{
              $t(
                'message.settingsComponent.list.switchCompany.myCompanies'
              )
            }}
          </span>
        </div>
        <template v-for="(userRelated, index) in usersRelatedList">
          <div
            class="w-11/12 flex mx-auto border rounded border-custom-gray box-custom-height md:h-32 mb-4" :key="`${index}`"
          >
            <div class="w-2/6 md:w-1/4 m-auto">
              <div class="w-24 h-16 md:w-32 md:h-20 flex justify-center items-center mx-auto border rounded border-custom-gray-2">
                <div
                  class="logo-company-change-box flex items-center justify-center"
                    v-show="imageLoaded"
                >
                  <img
                    :src="userRelated.empresa.logoBase64 || getImageUrl(userRelated.empresa.logo)"
                    @load="handleImageLoad"
                    @error="handleImageError"
                    alt=""
                  />
                  <div v-show="!imageLoaded" class="loading-placeholder">
                    <zt-icon name="image" class="text-zt-xl text-gray-400"/>
                  </div>
                </div>
              </div>
            </div>
            <div class="w-3/6 md:w-2/4 py-4 flex flex-wrap">
              <span class="w-full font-bold text-zt-dark-500">{{ userRelated.empresa.nombre }}</span>
              <span class="w-full company-info">{{ userRelated.pais }}</span>
            </div>
            <div class="w-1/6 md:w-1/4 my-auto flex justify-start items-end" v-if="!userRelated.blockedByPayment">
              <button
                v-show="!passwordExpired" 
                @click="switchCompanySession(userRelated.id, userRelated.estado_empresa)"
                class="w-10/12 h-12 custom-button"
              >
                <zt-icon name="sync" class="mr-2 -ml-6 text-zt-xl" />
                <span class="ml-2 text-zt-dark-300 align-middle hidden md:inline-flex">
                  {{
                    $t(
                      'message.settingsComponent.list.switchCompany.actionChangeCompany'
                    )
                  }}
                </span>
              </button>
            </div>
            <div class="w-1/6 md:w-1/4 my-auto flex justify-start items-end border-custom-red" v-else>
         {{$t("message.settingsComponent.list.switchCompany.blockedCompany")}}   
            </div>
          </div>
        </template>
      </template>
    </div>
        <zt-modal
            :active='onboardingPopUp'
            @close='onboardingPopUp = false'
            :title='this.$t("message.settingsComponent.list.switchCompany.onboardingAlert.header")'
        >
            <div class='flex justify-center items-center p-2'>
                <svg
                  class='m-4'
                  version="1.1"
                  id="Capa_1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  width="140"
                  height="140"
                  viewBox="0 0 70 70"
                  style="enable-background: new 0 0 70 70"
                  xml:space="preserve"
                  fill='none'
                  stroke="#FB8C00"
                  stroke-width="2"
                >
                  <g>
                    <circle class="st0" cx="35" cy="35" r="33.3" />
                    <path
                      class="st1"
                      fill='#FB8C00'
                      d="M35,69.3C16.1,69.3,0.7,53.9,0.7,35S16.1,0.7,35,0.7S69.3,16.1,69.3,35S53.9,69.3,35,69.3z M35,2.6
                    C17.2,2.6,2.6,17.2,2.6,35S17.2,67.4,35,67.4S67.4,52.8,67.4,35S52.8,2.6,35,2.6z"
                    />
                  </g>
                  <path
                    class="st2"
                      fill='#FB8C00'
                    d="M34.7,42.8c-0.9,0-1.7-0.8-1.7-1.7V22.2c0-0.9,0.8-1.7,1.7-1.7s1.7,0.8,1.7,1.7v18.9
                  C36.4,42,35.6,42.8,34.7,42.8z"
                  />
                  <path
                    class="st2"
                      fill='#FB8C00'
                    d="M34.7,48.2c0.9,0,1.7,0.8,1.7,1.7s-0.8,1.7-1.7,1.7s-1.7-0.8-1.7-1.7S33.7,48.2,34.7,48.2z"
                  />
                </svg>
                <div>
                    <div class='p-4 text-xl'>
                        {{ $t('message.settingsComponent.list.switchCompany.onboardingAlert.title') }}
                    </div>
                    <div class='p-4'>
                        {{ $t('message.settingsComponent.list.switchCompany.onboardingAlert.text', { relatedCompanyName }) }}
                    </div>
                </div>
            </div>
            <template slot='modal-footer'>
                <div class='zt-modal-footer flex justify-center lg:justify-end items-center p-4'>
                    <zt-button class='mr-1' outlined @click='onboardingPopUp = false'>
                        {{ $t('message.settingsComponent.list.switchCompany.onboardingAlert.cancelBtn') }}
                    </zt-button>
                    <zt-button
                        class='ml-1'
                        @click='switchCompanyAndLogOut()'
                    >
                        {{ $t('message.settingsComponent.list.switchCompany.onboardingAlert.confirmBtn') }}
                    </zt-button>
                </div>
            </template>
        </zt-modal>
    </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import Users from '../../../apiClient/Users'
import _ from 'lodash'
import Actions from '../../../apiClient/Actions'
import PasswordExpired from './PasswordExpired'

export default {
  name: 'switchCompany',
  components: { PasswordExpired },
  data() {
    return {
      company: {},
      companyState: '',
      currentCompany: {},
      loading: false,
      onboardingPopUp: false,
      passwordExpired: false,
      relatedCompanyName: '',
      userId: '',
      usersRelatedList: [],
      imageLoaded: false,
      companyLogo: '',
    }
  },
  computed: {
    ...mapGetters({ 
      getUsersRelated: 'getUsersRelated',
      getActions: 'getActions'
    })
  },
  async created() {
    this.user = new Users()
    this.actions = new Actions()
    this.company = this.$store.getters.getUser.empresa
    this.currentCompany = _.find(this.$store.getters.getUsersRelated, item => {
      return item.empresa.id === this.company.id
    })
    
    
    this.usersRelatedList = _.reject(
      _.filter(this.$store.getters.getUsersRelated, userRelated =>
        _.find(userRelated.perfiles, profile => profile.id_perfil_tipo === 1)
      ),
      company => company.id === this.currentCompany.id
    )
    

    if (this.currentCompany.empresa.logo) {
      try {
        const response = await this.user.getCompanyLogo(this.currentCompany.empresa.id);
        this.companyLogo = response.startsWith('http') ? 
          this.getImageUrl(response) : 
          'data:image/png;base64,' + response;
      } catch (error) {
        console.error('Error loading company logo:', error);
      }
    }

    this.usersRelatedList = await Promise.all(
      this.usersRelatedList.map(async (userRelated) => {
        if (userRelated.empresa.logo) {
          try {
            const response = await this.user.getCompanyLogo(userRelated.empresa.id);
            userRelated.empresa.logoBase64 = response.startsWith('http') ? 
              this.getImageUrl(response) : 
              'data:image/png;base64,' + response;
          } catch (error) {
            console.error('Error loading related company logo:', error);
          }
        }
        return userRelated;
      })
    );
  },
  methods: {
    ...mapMutations(['CLEAR_PROFILE']),
    ...mapActions([
      'setUser',
      'setActions',
      'clearState',
      'setCompanyLoginUrl',
      'resetConfig'
    ]),
    ...mapActions('home', ['setInitialBoards']),
    async switchCompanySession(userId, companyState) {
      this.$store.dispatch('clearPayrollStatus')
      this.userId = userId
      this.companyState = companyState
      const company = this.usersRelatedList.find(company => company.id === this.userId);
      this.relatedCompanyName = company.empresa.nombre;
      companyState === 2 ? this.onboardingPopUp = true : await this.switchCompany();
    },
    async switchCompanyAndLogOut() {
        this.$store.dispatch('documents/clearAllDocumentsState')   
        await this.user.switchcompany(this.userId);
        await this.user.logOut();
        this.$store.dispatch('setJwt', { jwt: '' });
        this.$store.dispatch('clearState');
        this.$router.push({ name: 'login' });
    },
    redirectToNewDashboard() {
      window.location.href = `${location.origin}/v3/`
    },
    setChangeRole(managerRole) {
      let isManagerRole
      if (managerRole == 'Colaborador') {
        isManagerRole = false
      } else {
        isManagerRole = true
      }
      this.$store.dispatch('isManagerRole', isManagerRole)
    },
    async switchCompany() {
      this.loading = true
        try {
            this.$store.dispatch('documents/clearAllDocumentsState')
            this.$store.dispatch('licenses/clearAllLicensesState')

            const userResponse = await this.user.switchcompany(this.userId)

            if (userResponse.data.code === '00607') {
              this.loading = false
              this.passwordExpired = true
              return
            }

            const {
              data: {
                results: { data }
              }
            } = userResponse

            const user = data[0]

            this.setUser({ user })

            if (user.aplicacion.dominio && user.aplicacion.dominio !== '') {
              this.setCompanyLoginUrl(user.aplicacion.dominio)
            }
            this.CLEAR_PROFILE()
            this.resetConfig()
            await this.$store.dispatch('refreshSichernPeopleIntegration')
            await this.setActions({ replace: true }).then(() => {
              this.loading = false
              this.redirectToNewDashboard()
            }).catch(error => {
              this.loading = false
              this.$swal({
                type: 'error',
                title: this.$t(
                  `message.errorReference.${error.response.data.response_v2.code}`
                ),
                showConfirmButton: true,
                confirmButtonText: this.$t('message.settingsComponent.list.okMsg')
              })
            })
            
            user.perfiles.some(objeto => objeto.id_perfil_tipo === 8) ? this.setChangeRole('Manager'): this.setChangeRole('Colaborador')
            this.user.getAvatarImage(user.id).then(response => {
              this.$emit('refreshAvatar', 'data:image/png;base64,' + response)
            })

            this.$emit( 'switch-company', { lastUserId: this.userId, currentUser: user, companyState: this.companyState });
        } catch (error) {
            this.loading = false
            this.$swal({
              type: 'error',
              title: this.$t(
                `message.errorReference.${error.response.data.response_v2.code}`
              ),
              showConfirmButton: true,
              confirmButtonText: this.$t('message.settingsComponent.list.okMsg')
            })
        }
    },
    goToSwitchCompany() {
      this.passwordExpired = false
      this.loading = false
    },
    getImageUrl(logoUrl) {
      const token = this.$store.getters.getJwt;
      if (!logoUrl) return '';
      if (logoUrl.startsWith('data:image')) return logoUrl;
      return `${logoUrl}${logoUrl.includes('?') ? '&' : '?'}token=${token}`;
    },
    async loadCompanyLogo(companyId) {
      try {
        const response = await this.user.getCompanyLogo(companyId);
        return 'data:image/png;base64,' + response;
      } catch (error) {
        console.error('Error loading company logo:', error);
        return '';
      }
    },
    handleImageLoad(event) {
      this.imageLoaded = true;
    },
    handleImageError(event) {
      console.error('Error loading image:', event.target.src);
      this.imageLoaded = true;
      event.target.parentElement.innerHTML = '<zt-icon name="image" class="text-zt-xl text-gray-400"/>';
    }
  }
}
</script>

<style scoped lang="scss">
.companies-container {
  max-height: 570px;
  overflow: auto;
}
.company-info {
  color: #575757;
}
.companies-title {
  color: #707070;
}
.border-custom-gray {
  border-color: #c1bfc0;
}
.border-custom-gray-2 {
  border-color: #cacaca;
}
.border-custom-red {
  border-color: red;
  color: red;
  font-size: 0.875rem; 
}
.custom-button:hover{
  background-color: rgba(111, 164, 244, 0.25);
  border-radius: 4px;
  span {
    color: #5c7bf4;
    font-weight: 600;
  }
}
@media (max-width: 768px) {
  .box-custom-height {
    height: 7rem;
  }
}
.logo-company-change-box {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

.loading-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f3f4f6;
}
</style>
